import { maybe, rd } from '@passionware/monads';
import { useSelector } from 'react-redux';
import {
  getProductionTypeById,
  getProductionTypesList
} from 'store/v1/production_types/production_types.selectors';
import { ProductionTypeService } from './ProductionTypeService';

export function createProductionTypeService(): ProductionTypeService {
  return {
    useProductionType(productionTypeId) {
      const productionType = useSelector(state =>
        getProductionTypeById(state, productionTypeId)
      );

      if (maybe.isAbsent(productionTypeId)) {
        return rd.ofIdle();
      }

      if (!productionType) {
        return rd.ofPending();
      }

      return rd.of(productionType);
    },
    useProductionTypes() {
      const productionTypes = useSelector(getProductionTypesList);
      return rd.of(productionTypes);
    }
  };
}
